/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Sitesettings_Item1Inputs */

const vi_sitesettings_item1 = /** @type {(inputs: Sitesettings_Item1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mục ${i?.n}`)
};

/**

* @param {Sitesettings_Item1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_item1 = /** @type {((inputs: Sitesettings_Item1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Item1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_item1(inputs)
});
export { sitesettings_item1 as "siteSettings_item" }